import { alerts } from './alerts';
import { avatar } from './avatar';
import { borderWidths } from './borderWidths';
import { breakpoints, mediaQueries } from './breakpoints';
import { buttons } from './buttons';
import { cards } from './cards';
import { colors } from './colors';
import { text } from './fonts';
import { fonts, fontSizes } from './fontSizes';
import { forms } from './forms';
import { grids } from './grids';
import { iconButtons } from './iconButtons';
import { messages } from './messages';
import { radii } from './radii';
import { shadows } from './shadows';
import { space } from './space';
import { styles } from './styles';
import { zIndices } from './zIndices';
const makeTheme = (t) => t;
const theme = makeTheme({
    config: {
        initialColorModeName: 'light',
        useColorSchemeMediaQuery: false,
    },
    zIndices,
    fontSizes,
    space,
    fonts,
    colors,
    buttons: Object.assign(Object.assign({}, buttons), iconButtons),
    images: Object.assign({}, avatar),
    text,
    messages,
    radii,
    shadows,
    breakpoints,
    alerts,
    mediaQueries,
    styles,
    links: text,
    forms,
    grids,
    borderWidths,
    cards,
});
export default theme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvdGhlbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUNsQyxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUM5QyxPQUFPLEVBQUUsV0FBVyxFQUFFLFlBQVksRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUMxRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBQ3BDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUNsQyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBQy9CLE9BQU8sRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBQy9DLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUNoQyxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQzVDLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFDdEMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUNoQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBQ3BDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUNsQyxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRXRDLE1BQU0sU0FBUyxHQUFHLENBQWtCLENBQUksRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0FBRS9DLE1BQU0sS0FBSyxHQUFHLFNBQVMsQ0FBQztJQUN0QixNQUFNLEVBQUU7UUFDTixvQkFBb0IsRUFBRSxPQUFPO1FBQzdCLHdCQUF3QixFQUFFLEtBQUs7S0FDaEM7SUFDRCxRQUFRO0lBQ1IsU0FBUztJQUNULEtBQUs7SUFDTCxLQUFLO0lBQ0wsTUFBTTtJQUNOLE9BQU8sa0NBQU8sT0FBTyxHQUFLLFdBQVcsQ0FBRTtJQUN2QyxNQUFNLG9CQUFPLE1BQU0sQ0FBRTtJQUNyQixJQUFJO0lBQ0osUUFBUTtJQUNSLEtBQUs7SUFDTCxPQUFPO0lBQ1AsV0FBVztJQUNYLE1BQU07SUFDTixZQUFZO0lBQ1osTUFBTTtJQUNOLEtBQUssRUFBRSxJQUFJO0lBQ1gsS0FBSztJQUNMLEtBQUs7SUFDTCxZQUFZO0lBQ1osS0FBSztDQUNOLENBQUMsQ0FBQztBQUlILGVBQWUsS0FBSyxDQUFDIn0=